import _ from 'lodash';
import { Plegma } from '@API/Api';
import { WebNode } from '@API/WebNode';
import { WebModule } from '@API/WebModule';
import { isDefined, RunSafe } from '@Utils/Micro';
import { Localization } from '@Primitive/Localization/Localization';
// ------------------------------------------------------------------------------------------------
export class DummyWebNode {
    // ------------------------------------------------------------------------------------------------
    /**
     * Static private cache for storing 1 callback per dummy webmodule
     * We need a way to 'catch' webmodule's port events
     * todo: find a more elegant way
     */
    private static webModuleKey2PortEventOutCB: { [key: string]: (events: Plegma.PortEvent[]) => void } = {};
    /**
     * Static for retrieving dummy WebNode
     */
    public static getDummyWebNodeAndWebModule(
        webModuleKey: string,
        portEventOutCB?: (events: Plegma.PortEvent[]) => void,
        dummyNodeKey: string = "just_a_dummy_node_key"
    ): { webNode: WebNode, webModule: WebModule } {

        // Create a dummy nodeKey
        let webNode = WebNode.GetInstanceKey(dummyNodeKey);
        if (webNode == null) {
            webNode = new WebNode({
                dummyWS: true,
                NodeKey: dummyNodeKey,
                ServerUrl: "",
                WebSocketUrl: "",
                ApplicationName: "",
                ApplicationUUID: "",
                ApplicationDescription: "",
                ApplicationImage: "",
                Keys: { nodeKey: dummyNodeKey, secretKey: "", token1: "", token2: "" },
                BoardId: ""
            }, true);

            webNode.DummyNode = true;
            webNode.DummyNodePortEventsOutCB = (thingKey: string, events: Plegma.PortEvent[]) => {
                _.forEach(this.webModuleKey2PortEventOutCB, (func, key) => {
                    if (thingKey.indexOf(key) !== -1)
                        RunSafe(func, events);
                });
            }

            // Create the localization fields for the dummy nodekey
            let localization = new Localization(dummyNodeKey, "default");

            // call `onConnected` so, we can call `onActivePortKeys` later
            webNode.YodiWS.onConnected(dummyNodeKey);
        }

        // register callback only once
        if (isDefined(portEventOutCB) &&
            !isDefined(this.webModuleKey2PortEventOutCB[webModuleKey]))
            this.webModuleKey2PortEventOutCB[webModuleKey] = portEventOutCB;

        return {
            webNode: webNode,
            webModule: webNode.GetModule(webModuleKey) || new WebModule(webNode, webModuleKey, webModuleKey)
        };
    }
    // ------------------------------------------------------------------------------------------------
    public static updatePortEventsOutCb(key: string, cb: (events: Plegma.PortEvent[]) => void) {
        if (_.isFunction(cb) && _.has(this.webModuleKey2PortEventOutCB, key))
            this.webModuleKey2PortEventOutCB[key] = cb;
    }
}